// @flow
import * as React from 'react';
import style from './style';
import type { Props } from './Props';

const AdminRow = ({ mail, users, onClick }: Props): React.Element<any> => (
  <tr style={style.rowStyle} onClick={onClick}>
    <td style={style.textStyle}>{mail}</td>
    <td style={style.textStyle}>{users}</td>
  </tr>
);

export default AdminRow;



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminList/components/AdminRow/AdminRow.js